import React from 'react';
import TabPropertyView from './TabProperty-view';
import file_small_1 from 'common/assets/mock/files_small/file_small_1.jpg';
import download from 'common/assets/download-4A4A4A.svg';
import share from 'common/assets/share-4A4A4A.svg';

const actions = [
  {
    label: 'הורדה',
    icon: download,
    onClick: () => console.log('download')
  },
  {
    label: 'שיתוף',
    icon: share,
    onClick: () => console.log('share')
  },
];

const TabProperty = () => {
  return (
    <TabPropertyView
      items={[
        {
          id: 1,
          name: 'file 1',
          type: 'jpg',
          association: 'paint',
          img: file_small_1,
          actions,
        },
        {
          id: 2,
          name: 'file 1',
          type: 'jpg',
          association: 'paint',
          img: file_small_1,
          actions,
        },
        {
          id: 3,
          name: 'file 1',
          type: 'jpg',
          association: 'paint',
          img: file_small_1,
          actions,
        },
      ]}
    />
  );
};

export default TabProperty;
